import { Body } from "@/components/Text/Body"
import { Display } from "@/components/Text/Display"
import { Title } from "@/components/Text/Title"

export const Text = {
	Title,
	Body,
	Display
}